module.exports = __webpack_public_path__ + "static/media/Lottery.54e8d490.svg";